import { render, staticRenderFns } from "./shopLevel.vue?vue&type=template&id=623ed129&"
import script from "./shopLevel.vue?vue&type=script&lang=js&"
export * from "./shopLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports